const ShowStarredTypes = {
  SHOW_STARRED: "SHOW_STARRED",
  REMOVE_STARRED_MESSAGE: "REMOVE_STARRED_MESSAGE",
};

export default ShowStarredTypes;
